export let videoProps = {
    controls: {
        type: Boolean,
        default: true
    },
    videoSrc: {
        default: ''
    },
    autoplay: {
        type: Boolean,
        default: false
    },
    muted: {
        type: Boolean,
        default: false
    },
    loop: {
        type: Boolean,
        default: false
    },
    poster: {
        default: null
    }

}